import { useMemo, useState } from "react";
import LimitedEditionIcon from "src/assets/all-icons/limited-edition-icon.jsx";

import config from "@/config";
import useProtectAction from "@/hooks/useProtectAction";
import useStateHandler from "@/hooks/useStateHandler";
import GalleryBuyDenied from "@/shared-components/popups/components/GalleryBuyDenied";
import Text from "@/shared-components/text/components/Text";

import BuyDetails from "../buy-details";

import LimitedEditionsSold from "./components/LimitedEditionsSold";

import "./index.css";

export default function BuyLimitedEditionButton({ artworkData }) {
  const { state } = useStateHandler();
  const [openBuyDetails, setOpenBuyDetails] = useState(false);
  const [openGalleryDeniedPopup, setOpenGalleryDeniedPopup] = useState(false);
  const privateActionHandler = useProtectAction({
    typeOfProtection: "USER_ACCOUNT_REQUIRED",
  });
  const areLimitedEditionsSold = useMemo(() => {
    if (artworkData.artwork_limited_editions) {
      for (const key in artworkData.artwork_limited_editions) {
        const limitedEditionSize = artworkData.artwork_limited_editions[key];

        if (
          Boolean(limitedEditionSize) &&
          limitedEditionSize.sold < limitedEditionSize.quantity
        ) {
          return false;
        }
      }

      return true;
    } else {
      return true;
    }
  }, []);

  function handleGetLimitedEdition() {
    if (state.user_session.user_type === "gallery") {
      setOpenGalleryDeniedPopup(true);
    } else {
      setOpenBuyDetails(true);
    }
  }

  if (!artworkData.artwork_limited_editions) {
    return (
      <>
        <div
          className="buy-limited-edition-button__container element-non-selectable not-available"
        >
        </div>
      </>
    );
  } else if (areLimitedEditionsSold) {
    return <LimitedEditionsSold artworkData={artworkData} />;
  } else {
    return (
      <>
        <div
          className="buy-limited-edition-button__container element-non-selectable"
          onClick={(e) => {
            e.stopPropagation();
            privateActionHandler(handleGetLimitedEdition);
          }}
        >
          <LimitedEditionIcon className="buy-limited-edition-button__icon" />
          <div className="buy-limited-edition-button__text_container">
            <Text className="buy-limited-edition-button__text-info" large>
            Buy Limited Edition
            </Text>
            <Text className="buy-limited-edition-button__text-description" extraSmall>
            From {config.variables.LIMITED_EDITION_SMALL_PRICE}€
            </Text>
          </div>

        </div>

        <GalleryBuyDenied
          open={openGalleryDeniedPopup}
          close={() => setOpenGalleryDeniedPopup(false)}
        />

        <BuyDetails
          open={openBuyDetails}
          close={() => setOpenBuyDetails(false)}
          artworkData={artworkData}
          typeOfPurchase="limited_edition"
        />
      </>
    );
  }
}
